export default [
  {
    key: 'tran_id',
    label: 'field.partnerTransactionId',
    type: 'text',
    cols: 12,
  },
]
